@if (isOpen()) {
  <div
    #dropdownContainer
    class="dropdown"
    [class.dropdown--above]="openAbove()"
    [class.dropdown--submenu-expanded]="expandedSubmenuIndex() >= 0"
    [style.max-height]="maxHeight()"
    (keydown)="onKeyDown($event)"
    tabindex="0"
    role="listbox"
    [attr.aria-label]="'Dropdown menu'"
  >
    @if (searchable()) {
      <div class="dropdown__search">
        <input
          #searchInput
          type="text"
          class="dropdown__search-input"
          [placeholder]="searchPlaceholder()"
          [value]="searchText()"
          (input)="onSearchInput($event)"
          (mousedown)="$event.stopPropagation()"
        />
      </div>
    }
    @for (item of visibleItems(); track item.id; let i = $index) {
      @if (item.id === '__separator__') {
        <div class="dropdown__separator" role="separator"></div>
      } @else {
        <div
          class="dropdown__item"
          [class.dropdown__item--selected]="isItemSelected(item)"
          [class.dropdown__item--focused]="isItemFocused(i)"
          [class.dropdown__item--child]="item.isChild"
          [class.dropdown__item--has-submenu]="item.children?.length"
          (mousedown)="$event.preventDefault(); selectItem(item)"
          (mouseenter)="onItemMouseEnter(i)"
          role="option"
          [attr.aria-selected]="isItemSelected(item)"
          [attr.aria-expanded]="item.children?.length ? isSubmenuExpanded(i) : null"
        >
          <div class="dropdown__item-content">
            <span class="dropdown__item-label" [innerHTML]="item.label | translateLang"></span>
            @if (item.secondaryText) {
              <div class="dropdown__item-badge">
                <span class="dropdown__item-badge-text">
                  @if (item.secondaryTextPrefix) {
                    {{ item.secondaryTextPrefix | translateLang }} :
                  }
                  {{ item.secondaryText }}
                </span>
              </div>
            }
            @if (item.children?.length) {
              <button
                type="button"
                class="dropdown__item-expand-btn"
                (mousedown)="$event.preventDefault(); $event.stopPropagation(); toggleSubmenu(i)"
                aria-label="Expand submenu"
              >
                <app-caret-icon
                  [isOpen]="isSubmenuExpanded(i)"
                  [customClass]="'dropdown__item-caret'"
                >
                </app-caret-icon>
              </button>
            }
          </div>
        </div>

        <!-- Sub-items expand inline beneath their parent (same behaviour as the mobile menu) -->
        @if (item.children?.length && isSubmenuExpanded(i)) {
          <div class="dropdown__submenu" role="group">
            @for (child of item.children!; track child.id) {
              <div
                class="dropdown__submenu-item"
                role="option"
                [attr.aria-selected]="isItemSelected(child)"
                (mousedown)="$event.preventDefault(); selectItem(child)"
              >
                <span class="dropdown__submenu-item__label">{{ child.label | translateLang }}</span>
              </div>
            }
          </div>
        }
      }
    }
    @if (searchable() && visibleItems().length === 0) {
      <div class="dropdown__empty">{{ noResultsLabel() }}</div>
    }
  </div>
}
